<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/FToNUR/tc-custom/9781035857906.jpg?1728726114326" alt="This image is the cover for the book Siege XV"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Siege XV
      </h1>
      <p class="bookDescription body article font2">
        <p>The sovereignty of a small but crucial piece of land is at stake. Besieged and fought over fourteen times throughout its history, Jebel-Tarik, or Tarik’s Hill – named after an eighth-century Muslim invader – came to be known as the Rock of Gibraltar. This strategically located fortress controls the trade routes between Europe and North Africa, linking the Atlantic Ocean with the Mediterranean and the Middle East. Its possession can dictate the flow of commerce and industry in this volatile region. In a bid to expel the British, King Carlos of Spain allies with the French. Meanwhile, two young farm lads from Lancashire embark on separate journeys that lead them to converge on this contested ground, each playing a role in the unfolding drama. This is the story of the last great siege of Gibraltar, detailing the armies and navies involved and the heroic actions of soldiers and sailors on both sides. Who will prevail: Britain or Spain?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Peter R Leaver
      </h2>
      
      <p class="authorDescription body article">Peter Robinson Leaver was born in 1946 and was educated at Queen Elizabeth’s Grammar School in Blackburn, Lancashire. He subsequently attained a BSc in Earth and Environmental Sciences with the Open University whilst enjoying a career in the Ministry of Defence working with all three-armed services. He fell in love with Gibraltar during a bird-surveying expedition with the RAF, observing migrating birds of prey as they crossed over from Africa. He returned on several occasions to research material for Siege XV and began writing as a hobby. Now retired from his ‘proper job’, Peter works part-time for a national wine company, enjoying the fruits of his labours. He is unmarried and lives in the Wiltshire countryside but remains a passionate Blackburn Rovers fan.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d86ef8dc